import { useEffect, useState } from "react";
import { debounce } from "../utils/debounce";

interface ScreenSizeResult {
  isSmallScreen: boolean | undefined;
}

const useScreenSize = (): ScreenSizeResult => {
  const [isSmallScreen, setIsSmallScreen] = useState<boolean | undefined>(
    undefined,
  );

  useEffect(() => {
    const check = () => setIsSmallScreen(window.innerWidth < 768);
    const debouncedCheck = debounce(check, 150);

    check();

    window.addEventListener("resize", debouncedCheck);
    return () => window.removeEventListener("resize", debouncedCheck);
  }, []);

  return { isSmallScreen };
};

export default useScreenSize;
